(() => {
  document.querySelectorAll("[data-wb-number-dialog]").forEach((dialog) => {
    const section = dialog.closest("section");
    const form = section && section.querySelector("[data-configurator]");
    const grid = dialog.querySelector("[data-wb-number-grid]");
    const summary = dialog.querySelector("[data-wb-number-summary]");
    const feedback = dialog.querySelector("[data-wb-number-feedback]");
    const search = dialog.querySelector("[data-wb-number-search]");
    const check = dialog.querySelector("[data-wb-number-check]");
    const selectedLabel = dialog.querySelector("[data-wb-number-selected]");
    const confirm = dialog.querySelector("[data-wb-number-confirm]");
    const size = Number.parseInt(dialog.dataset.editionSize || "0", 10);
    if (!form || !grid || !size) return;

    let variants = [];
    let numbers = new Map();
    let selected = null;

    const format = (number) => `No. ${String(number).padStart(3, "0")}`;
    const parseNumber = (value) => {
      const match = /^No\.\s*0*([1-9]\d*)$/i.exec(String(value || "").trim());
      return match ? Number(match[1]) : null;
    };
    const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/?$/, "/");

    function indexVariants() {
      numbers = new Map();
      variants.forEach((variant) => {
        const number = parseNumber(variant.option1 || variant.option);
        if (number && number <= size) {
          numbers.set(number, { id: String(variant.id), available: Boolean(variant.available) });
        }
      });
    }

    function render() {
      indexVariants();
      const availableCount = [...numbers.values()].filter((variant) => variant.available).length;
      summary.textContent = numbers.size
        ? `${availableCount} of ${size} numbers currently available. Select the exact number you want.`
        : "Number selection is being prepared. Please check back shortly.";
      grid.replaceChildren();
      const fragment = document.createDocumentFragment();
      for (let number = 1; number <= size; number += 1) {
        const variant = numbers.get(number);
        const button = document.createElement("button");
        button.type = "button";
        button.dataset.number = String(number);
        button.textContent = format(number);
        button.disabled = !variant || !variant.available;
        button.setAttribute("aria-label", `${format(number)} — ${button.disabled ? "unavailable" : "available"}`);
        button.setAttribute("aria-pressed", String(Boolean(selected && selected.number === number && !button.disabled)));
        fragment.append(button);
      }
      grid.append(fragment);
      if (selected && (!numbers.get(selected.number) || !numbers.get(selected.number).available)) {
        selected = null;
        selectedLabel.textContent = "Select an available number";
        confirm.disabled = true;
      }
    }

    async function refresh() {
      try {
        const url = new URL(`${root}products/${encodeURIComponent(form.dataset.handle)}.js`, location.origin);
        const response = await fetch(url, { cache: "no-store", credentials: "same-origin" });
        if (!response.ok) throw new Error("Product inventory could not be loaded");
        const product = await response.json();
        if (!Array.isArray(product.variants)) throw new Error("Product inventory is incomplete");
        variants = product.variants;
        return true;
      } catch (_) {
        variants = [];
        return false;
      }
    }

    function select(number) {
      const variant = numbers.get(number);
      if (!variant || !variant.available) {
        feedback.textContent = `${format(number)} is unavailable. Choose another number.`;
        return;
      }
      selected = { number, id: variant.id };
      selectedLabel.textContent = `${format(number)} of ${size} selected`;
      confirm.textContent = `Secure ${format(number)}`;
      confirm.disabled = false;
      feedback.textContent = "";
      grid.querySelectorAll("button").forEach((button) => {
        button.setAttribute("aria-pressed", String(Number(button.dataset.number) === number));
      });
      section.querySelectorAll("[data-wb-number-choice]").forEach((node) => {
        node.textContent = `${format(number)} of ${size} selected. You can change it before adding to cart.`;
      });
    }

    section.querySelectorAll("[data-wb-number-open]").forEach((button) => {
      button.addEventListener("click", async () => {
        feedback.textContent = "Checking current availability…";
        if (!dialog.open) dialog.showModal();
        const loaded = await refresh();
        render();
        feedback.textContent = loaded ? "" : "We could not check availability. Please try again.";
        search.focus();
      });
    });
    dialog.querySelector("[data-wb-number-close]").addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) dialog.close();
    });
    grid.addEventListener("click", (event) => {
      const button = event.target.closest("button[data-number]");
      if (button && !button.disabled) select(Number(button.dataset.number));
    });
    function checkRequestedNumber() {
      const number = Number.parseInt(search.value.replace(/\D/g, ""), 10);
      if (!number || number < 1 || number > size) {
        feedback.textContent = `Enter a number from 1 to ${size}.`;
        return;
      }
      select(number);
      const button = grid.querySelector(`button[data-number="${number}"]`);
      if (button) button.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
    check.addEventListener("click", checkRequestedNumber);
    search.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      checkRequestedNumber();
    });

    confirm.addEventListener("click", async () => {
      if (!selected) return;
      confirm.disabled = true;
      feedback.textContent = "Checking that number is still available…";
      const loaded = await refresh();
      render();
      if (!loaded) {
        feedback.textContent = "We could not check availability. Please try again.";
        return;
      }
      if (!selected) {
        feedback.textContent = "That number was just claimed. Please choose another.";
        return;
      }
      const variant = numbers.get(selected.number);
      if (!variant || !variant.available) {
        feedback.textContent = "That number was just claimed. Please choose another.";
        selected = null;
        return;
      }
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1, properties: { "Edition Number": format(selected.number) } }] }),
        });
        if (!response.ok) {
          await refresh();
          render();
          feedback.textContent = "That number could not be added. Please choose another available number.";
          confirm.disabled = false;
          return;
        }
        if (window.dataLayer && typeof window.dataLayer.push === "function") {
          window.dataLayer.push({ event: "cs_add_to_cart", campaign: "wrights-of-passage", edition_number: format(selected.number), variant_id: variant.id });
        }
        const attributes = { landing_page: "wrights-of-passage/numbered-product" };
        new URLSearchParams(location.search).forEach((value, key) => {
          if (/^(utm_|fbclid$|gclid$|ttclid$|cs_)/.test(key)) attributes[key] = value;
        });
        try {
          await fetch(`${root}cart/update.js`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ attributes }),
          });
        } catch (_) {
        }
        location.assign(`${root}cart`);
      } catch (_) {
        feedback.textContent = "We could not reach the cart. Please try again.";
        confirm.disabled = false;
      }
    });
    render();
  });
})();
